import React from "react";
import styles from "./Footer.module.css";
import { FaInstagram, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div id="contact" className={styles.container}>
      <div className={styles.footerTop}></div>
      <div className={styles.logo}>
        <hr />
        <img src="./assets/logo.png" alt="" />
        <hr />
      </div>
      <div className={styles.logoName}>
        Space.<span>Labs</span>
      </div>
      <div className={styles.contacts}>
        <div className={styles.icons}>
          <Link
            to={"https://www.linkedin.com/company/space_labs/"}
            target="_blank"
          >
            <FaLinkedinIn />
          </Link>{" "}
          <p className={styles.ph_number}>
            +91 9811877945 <span> +91 (0) 120-2341065/66</span>{" "}
          </p>
        </div>
        <p className={styles.email}>contact@space-labs.in</p>
        <p>© {new Date().getFullYear()} Space Labs</p>
      </div>
    </div>
  );
};

export default Footer;
